import React from 'react';
import ToolCard from './ToolCard';

/**
 * ToolCategory — labeled section that renders every tool inside a
 * single category (Get Answers, Protect Your Rights, etc). Fully
 * hidden when the filtered list is empty (parent handles messaging).
 */
export default function ToolCategory({ category, tools, onSelect }) {
  if (!tools || tools.length === 0) return null;
  return (
    <section aria-labelledby={`cc-cat-${category.id}-title`} data-testid={`cc-category-${category.id}`}>
      <header className="cc-section-head">
        <h2 id={`cc-cat-${category.id}-title`} className="cc-section-title">
          {category.title}
        </h2>
        <span className="cc-section-title-underline" aria-hidden="true" style={{ background: category.accent || '#facc15' }} />
        <p className="cc-section-sub">{category.subtitle}</p>
      </header>
      <div className="cc-grid">
        {tools.map((t) => (
          <ToolCard key={t.id} tool={t} onSelect={onSelect} />
        ))}
      </div>
    </section>
  );
}
